import { Box, Text } from "@chakra-ui/react";

export function CardInfoOfertasExclusivas({ ativadas, disponiveis }) {
  return (
    <Box padding="0.5rem" background="#fff" borderRadius="md" boxShadow="md">
      <Text color="#555861" fontSize="sm">
        Ofertas exclusivas do aplicativo
      </Text>
      <Box display="flex" justifyContent="space-between" marginTop="1rem">
        <Box
          background="#EDEEF2"
          padding="1rem"
          width="47.5%"
          borderRadius="sm"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDir="column"
        >
          <Text color="#0B0C0D" fontSize="1rem">
            Disponíveis: {disponiveis}
          </Text>
        </Box>
        <Box
          background="#EDEEF2"
          padding="1rem"
          width="47.5%"
          borderRadius="sm"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDir="column"
        >
          <Text color="#0B0C0D" fontSize="1rem">
            Ativadas: {ativadas}
          </Text>
        </Box>
      </Box>
    </Box>
  );
}
